// Model.js
// -----------------------
// @module Case
define("Eureka.MaxaCategoryIcons.MaxaCategoryIcons.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/MaxaCategoryIcons/SuiteScript2/MaxaCategoryIcons.Service.ss"
            ),
            true
        )
});
});
